module.exports = __webpack_public_path__ + "img/home_image_jinribaom@2x.30440c29.png";